import React, { useState } from 'react'
import ChargebeeCardForm from './ChargebeeCardForm'

const ChargebeeCardFormContainer = ({
  onRequestClose,
}: {
  onRequestClose: (...args: Array<any>) => any
}): React.ReactNode => {
  const [updateModal, setUpdateModal] = useState(null)
  return (
    <>
      <ChargebeeCardForm
        setUpdateModal={setUpdateModal}
        onRequestCloseUpdateModal={onRequestClose}
      />
      {updateModal}
    </>
  )
}

export default ChargebeeCardFormContainer
